import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import OrderEmergensiSvc from "@/services/OrderEmergensi";
import {
  CpoEmergensiOrder,
  OrderEmergensi,
  PaketObatEmergensi
} from "@/types/order_emergensi";

let tokenDaftar = 0;
let tokenCpo = 0;

@Module({ store, dynamic: true, namespaced: true, name: "order-emergensi" })
class OrderEmergensiModule extends VuexModule {
  registerId: string | null = null;
  list: OrderEmergensi[] = [];
  cpoList: CpoEmergensiOrder[] = [];
  paketAktif: PaketObatEmergensi[] = [];
  loading = false;
  loadingCpo = false;
  loadingPaket = false;

  @Mutation SET_REGISTER(registerId: string | null) {
    if (this.registerId !== registerId) {
      this.list = [];
      this.cpoList = [];
    }
    this.registerId = registerId;
  }

  @Mutation SET_LIST(list: OrderEmergensi[]) {
    this.list = list;
  }

  @Mutation SET_CPO_LIST(list: CpoEmergensiOrder[]) {
    this.cpoList = list;
  }

  @Mutation SET_PAKET(list: PaketObatEmergensi[]) {
    this.paketAktif = list;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation SET_LOADING_CPO(val: boolean) {
    this.loadingCpo = val;
  }

  @Mutation SET_LOADING_PAKET(val: boolean) {
    this.loadingPaket = val;
  }

  @Mutation UPSERT(order: OrderEmergensi) {
    const idx = this.list.findIndex(o => o.id === order.id);
    if (idx >= 0) {
      this.list.splice(idx, 1, order);
    } else {
      this.list.unshift(order);
    }
  }

  @Action async muatPaket(paksa = false) {
    if (this.paketAktif.length && !paksa) return;
    this.SET_LOADING_PAKET(true);
    try {
      const resp = await OrderEmergensiSvc.getPaketAktif();
      this.SET_PAKET(resp.data.data || []);
    } catch {
      this.SET_PAKET([]);
    } finally {
      this.SET_LOADING_PAKET(false);
    }
  }

  @Action async muatDaftar(registerId: string) {
    const token = ++tokenDaftar;
    this.SET_REGISTER(String(registerId));
    this.SET_LOADING(true);
    try {
      const resp = await OrderEmergensiSvc.getByRegister(registerId);
      if (token !== tokenDaftar) return;
      this.SET_LIST(resp.data.data || []);
    } catch {
      if (token === tokenDaftar) this.SET_LIST([]);
    } finally {
      if (token === tokenDaftar) this.SET_LOADING(false);
    }
  }

  @Action async muatCpo(registerId: string) {
    const token = ++tokenCpo;
    this.SET_REGISTER(String(registerId));
    this.SET_LOADING_CPO(true);
    try {
      const resp = await OrderEmergensiSvc.getCpoByRegister(registerId);
      if (token !== tokenCpo) return;
      this.SET_CPO_LIST(resp.data.data || []);
    } catch {
      if (token === tokenCpo) this.SET_CPO_LIST([]);
    } finally {
      if (token === tokenCpo) this.SET_LOADING_CPO(false);
    }
  }

  @Action reset() {
    tokenDaftar++;
    tokenCpo++;
    this.SET_REGISTER(null);
    this.SET_LOADING(false);
    this.SET_LOADING_CPO(false);
  }
}

export const storeOrderEmergensi = getModule(OrderEmergensiModule);
